import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils";

export const UserCircleIcon = ({ className, ...props }: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge("size-5", className)}
    {...props}
  >
    <path
      d="M14.7058 14.3953C14.4083 13.8124 14.0157 13.2656 13.5281 12.778C11.0273 10.2772 6.97279 10.2772 4.47204 12.778C3.98435 13.2656 3.59177 13.8124 3.2943 14.3953M0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5564 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM12 7.5C12 9.15685 10.6569 10.5 9 10.5C7.34315 10.5 6 9.15685 6 7.5C6 5.84314 7.34315 4.5 9 4.5C10.6569 4.5 12 5.84314 12 7.5Z"
      stroke="currentColor"
      strokeWidth="1.67"
    />
  </svg>
);
